export enum UserProfileType {
  organisation = 'organisation',
  business_partner = 'business_partner',
  parent = 'parent',
  guardian = 'guardian',
  interviewer = 'interviewer',
}
